import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import IconSelector from "../commoncomponents/IconSelector";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import "../../styles/groups/groups.scss";

class CreateGroup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customerList: [],
      roles: [],
      customerID: "default",
      name: "",
      description: "",
      color: "#160f9e",
      icon: "fa fa-truck",
      status: "1",
      customerID_error: false,
      name_error: false,
    };
    this.formSubmit = false;
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.selectedAsset) {
      this.setState({ customerID: values.customerId });
    }
    this.props.setLoadingPageAction(true);

    //Get all customer id
    try {
      const customerList = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ customerList: customerList.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ customerID_error: true });
    } else {
      this.setState({ customerID_error: false });
    }
    this.setState({ customerID: e.target.value });
  }

  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }

  handleColorChange = (e) => {
    this.setState({ color: e.target.value });
  }

  getColorPickerValue = () => {
    const color = String(this.state.color || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : "#160f9e";
  }

  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  handleConfirmIconChange(e) {
    this.setState({ icon: e.target.value });
  }

  handleIconSelection = (icon) => {
    this.setState({ icon });
  }

  handleVisualDefaults = () => {
    this.setState({
      color: "#160f9e",
      icon: "fa fa-truck",
    });
  }

  handleStatusChange(e) {
    this.setState({ status: e.target.value });
    console.log(e.target.value);
  }

  getSelectedCustomerName = () => {
    const selectedCustomer = this.state.customerList.find(
      (customer) => customer.id.toString() === this.state.customerID.toString()
    );

    return selectedCustomer ? selectedCustomer.name : "Select customer";
  }

  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }

    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        await axios.post(
          `${apiHost}/api/Group/GroupRegister`,
          {
            Name: this.state.name,
            CustomerId: this.state.customerID,
            Description: this.state.description,
            Colour: this.state.color,
            Icon: this.state.icon,
            Status: this.state.status,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.props.history.goBack();
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          // this.props.setErrorMessageAction(`${e}`);
          if (e.response.data.statusCode == "8") {
            this.props.setErrorMessageAction("Group Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  render() {
    const values = queryString.parse(this.props.location.search);
    var selectCustomerTag;
    if (values.selectedAsset) {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
          value={this.state.customerID}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option key={index} value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    } else {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option key={index} value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    }
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Create Group </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper group-create-page">
              <div className="group-create-header">
                <div>
                  <span className="group-create-kicker">Group creator</span>
                  <h2>Create Group</h2>
                  <div className="group-create-subtitle">
                    <span>{this.getSelectedCustomerName()}</span>
                    <span className={this.state.status === "1" ? "record-badge-active" : "record-badge-disabled"}>
                      {this.state.status === "1" ? "Active" : "Disabled"}
                    </span>
                  </div>
                </div>
                <div className="group-create-actions">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Create Group
                  </Button>
                </div>
              </div>

              <Form className="group-create-form-modern">
                <section className="group-create-section">
                  <div className="group-create-section-title">
                    <h3>Group Identity</h3>
                    <p>Customer ownership, name and descriptive details.</p>
                  </div>
                  <div className="group-create-grid">
                    <Form.Group controlId="groupCustomer">
                      <Form.Label>Customer</Form.Label>
                      {selectCustomerTag}
                      <p className={this.state.customerID_error ? "group-create-error" : "group-create-error hidden"}>
                        The Customer field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="groupName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        onChange={this.handleNameChange.bind(this)}
                      />
                      <p className={this.state.name_error ? "group-create-error" : "group-create-error hidden"}>
                        The Name field is required.
                      </p>
                    </Form.Group>

                    <Form.Group className="group-create-wide" controlId="groupDescription">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        onChange={this.handleDescriptionChange.bind(this)}
                        rows="3"
                      />
                    </Form.Group>
                  </div>
                </section>

                <section className="group-create-section">
                  <div className="group-create-section-title">
                    <h3>Visual Settings</h3>
                    <p>Colour and icon used when this group appears in the platform.</p>
                  </div>
                  <div className="group-create-grid">
                    <Form.Group controlId="groupColour">
                      <Form.Label>Colour</Form.Label>
                      <div className="colour-picker-field">
                        <Form.Control
                          type="color"
                          value={this.getColorPickerValue()}
                          onChange={this.handleColorChange.bind(this)}
                          title="Choose colour"
                        />
                        <Form.Control
                          type="text"
                          value={this.state.color}
                          onChange={this.handleColorChange.bind(this)}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="group-create-wide" controlId="groupIcon">
                      <Form.Label>Icon</Form.Label>
                      <IconSelector
                        value={this.state.icon}
                        onChange={this.handleIconSelection}
                      />
                      <div className="group-create-icon-row">
                        <Form.Control
                          type="text"
                          value={this.state.icon}
                          onChange={this.handleConfirmIconChange.bind(this)}
                        />
                        <button type="button" className="visual-default-button" onClick={this.handleVisualDefaults}>
                          Back to default
                        </button>
                      </div>
                    </Form.Group>
                  </div>
                </section>

                <section className="group-create-section">
                  <div className="group-create-section-title">
                    <h3>Availability</h3>
                    <p>Set whether this group can be used immediately.</p>
                  </div>
                  <div className="group-create-grid">
                    <Form.Group controlId="groupStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleStatusChange.bind(this)}
                        value={this.state.status}
                      >
                        <option value="1">Active</option>
                        <option value="0">Disabled</option>
                      </Form.Control>
                    </Form.Group>
                  </div>
                </section>

                <div className="group-create-footer">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Create Group
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateGroup);
